export default {
  xs: "0.75rem", // text-xs
  sm: "0.875rem", // text-sm
  base: "1rem", // text-base
  lg: "1.125rem", // text-lg
  xl: "1.25rem", // text-xl
  "2xl": "1.5rem", // text-2xl
  "3xl": "1.875rem", // text-3xl
  "4xl": "2.25rem", // text-4xl
  "5xl": "3rem", // text-5xl
  "6xl": "3.75rem", // text-6xl
  "7xl": "4.5rem", // text-7xl
  "8xl": "6rem", // text-8xl
  "9xl": "8rem", // text-9xl
};
